module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/a0129-mmibun/mmibun.component.css
// module id = ./src/app/a0129-mmibun/mmibun.component.css
// module chunks = main